/**
 * 在移动端中展示分页列表封装
 * 2020-11-30 
 * chenxiaojian
 */
import React from 'react';

import { ListView } from 'antd-mobile';

import http from "../../../axios/wechatHttp";

import messager from '../../ui/messager';


class pageList extends React.Component {

    state = {
        dataSource: new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        }),
        loading: false, //是否正在加载中
        data: [], //已经加载的数据
        pagination: {
            pageSize: 20
        }, //分页数据
        params: {}, //查询参数
    };

    componentDidMount() {
        if (this.props.loadData !== undefined && this.props.loadData != null) {
            this.props.loadData(this.loadData);
        }
        this.loadData();
    }

    filter = (params = {}) => {
        this.setState({ loading: true });
        const { url } = this.props;
        let requestType = this.props.requestType;
        let httpObject = {
            url: url,
            data: { ...params },
            success: (res) => {
                const pagination = { ...this.state.pagination };
                pagination.pageSize = res.pageSize;
                pagination.pageNumber = res.pageNumber;
                pagination.total = res.totalElements;
                pagination.totalPages = res.totalPages;
                let data = this.state.data;
                if (res.content != null && res.content.length > 0) {
                    data = data.concat(res.content);
                }
                this.setState({
                    loading: false,
                    data: data,
                    pagination,
                    dataSource: this.state.dataSource.cloneWithRows(data),
                    params: params
                });
            },
            error: (res) => {
                messager.alert(res, "异常", "error");
                this.setState({ loading: false });
            }
        };
        if (requestType === 'get') {
            http.get(httpObject);
        } else {
            http.post(httpObject);
        }
    }

    loadData = (params = {}) => {
        params.pageSize = this.props.pageSize ? this.props.pageSize : this.state.pagination.pageSize;
        params.pageNumber = 1;
        this.filter(params);
    }

    onEndReached = (event) => {
        let { pagination, loading, params } = this.state;
        //如果已经在加载中，或者是最后一页，则不需要再发起请求
        if (loading || pagination.pageNumber === pagination.totalPages) {
            return;
        }
        params.pageSize = pagination.pageSize;
        params.pageNumber = ++pagination.pageNumber;
        this.filter(params);
    }

    rowSeparator = (sectionID, rowID) => {
        return (<div
            key={`${sectionID}-${rowID}`}
            style={{
                backgroundColor: '#F5F5F9',
                height: 8,
                borderTop: '1px solid #ECECED',
                borderBottom: '1px solid #ECECED',
            }}
        />)
    }

    renderFooter = () => {
        return (<div style={{ padding: 30, textAlign: 'center' }}>
            {this.state.loading ? 'Loading...' : ''}
        </div>);
        // let { pagination, loading } = this.state;
        // let dom = <div style={{ padding: 30, textAlign: 'center' }}>Loading...</div>;
        // if (!loading) {
        //     dom = "";
        // }
        // return dom;
    }

    render() {
        return (
            <ListView
                dataSource={this.state.dataSource}
                renderRow={this.props.renderRow}
                renderSeparator={this.props.rowSeparator ? this.props.rowSeparator : this.rowSeparator}
                renderFooter={this.renderFooter}
                style={{
                    height: '100%',
                    overflow: 'auto',
                }}
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
            />
        );
    }
}

export default pageList;